import React from 'react';
import { connect } from 'react-redux';
import BlemishReportVersion1 from './BlemishReportVersion1';
import BlemishReportVersion2 from './BlemishReportVersion2';
import { getVal } from '../../../../../../shared/helpers';
import BlemishReportVersion3 from './BlemishReportVersion3';
import BlemishReportVersion4 from './BlemishReportVersion4';
import BlemishReportVersion5 from './BlemishReportVersion5';

class BlemishReportModal extends React.Component {
    render() {
        return this.props.blemish_report_version === undefined || this.props.blemish_report_version === '1'
            ? (
                <BlemishReportVersion1
                    closeModal={this.props.closeModal}
                />
            )
            : this.props.blemish_report_version === '2'
                ? (
                    <BlemishReportVersion2
                        closeModal={this.props.closeModal}
                    />
                )
                : this.props.blemish_report_version === '3'
                    ? (
                        <BlemishReportVersion3
                            closeModal={this.props.closeModal}
                        />
                    )
                    : this.props.blemish_report_version === '4'
                        ? (
                            <BlemishReportVersion4
                                closeModal={this.props.closeModal}
                            />
                        )
                        : (
                            <BlemishReportVersion5
                                closeModal={this.props.closeModal}
                            />
                        );
    }
}

const mapStateToProps = state => ({
    blemish_report_version: getVal(state, 'Leads.Lead_profile.Lead_blemish_report.blemish_report.questions_version'),
});

export default connect(mapStateToProps, null)(BlemishReportModal);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_blemish_report/components/BlemishReportModal.js